import Permissions, {
  PermissionsEnum,
  loanApplicationsPermissions,
} from '../utils/constants/Permissions';

const {
  CAN_READ_LEGAL_LOANS,
  CAN_READ_LOANS,
  CAN_READ_PROFILES,
  CAN_READ_PERMISSIONS,
  CAN_CREATE_PERMISSIONS,
  CAN_READ_MOVEMENTS,
  CAN_READ_MOVEMENTS_SUMMARY,
  CAN_READ_BANK_ACCOUNTS,
  CAN_READ_LOAN_APPLICATIONS_IN_GENERAL,
  CAN_READ_LOAN_APPLICATIONS_IN_VALIDATION,
  CAN_READ_BROKERS,
  CAN_READ_DEPARTMENTS,
  CAN_READ_GROUPS,
  CAN_READ_POSITIONS,
  CAN_CREATE_LOAN_APPLICATION_FROM_CRM,
} = PermissionsEnum;

const {
  CAN_READ_PRODUCTS,
  CAN_READ_WALLET_USERS,
  CAN_EDIT_TERMS_AND_CONDITIONS_OF_USE,
} = Permissions;

const urls = [
  {
    title: 'Navegación',
    items: [
      {
        pathname: '/',
        url: '/',
        icon: 'ion-ios-list-outline',
        title: 'Inicio',
        private: false,
        mandatoryPermissions: [],
        permissions: [],
        items: [],
      },
      {
        icon: 'sli-menu',
        title: 'Solicitudes',
        private: false,
        items: [
          {
            pathname: '/solicitudes',
            url: '/solicitudes?page=1',
            title: 'General',
            private: false,
            mandatoryPermissions: [CAN_READ_LOAN_APPLICATIONS_IN_GENERAL],
            permissions: [...loanApplicationsPermissions],
          },
          {
            pathname: '/solicitudes/archivados',
            url: '/solicitudes/archivados?page=1',
            title: 'Archivados',
            private: false,
            mandatoryPermissions: [CAN_READ_LOAN_APPLICATIONS_IN_GENERAL],
            permissions: [...loanApplicationsPermissions],
          },
          {
            pathname: '/validacion',
            url: '/validacion?page=1',
            title: 'Validación',
            private: false,
            mandatoryPermissions: [CAN_READ_LOAN_APPLICATIONS_IN_VALIDATION],
            permissions: [...loanApplicationsPermissions],
          },
        ],
      },
      {
        icon: 'sli-menu',
        title: 'Préstamos',
        private: false,
        items: [
          {
            pathname: '/prestamos',
            url: '/prestamos?page=1',
            title: 'iBAN ONLINE',
            private: false,
            mandatoryPermissions: [],
            permissions: [CAN_READ_LOANS],
          },
          {
            pathname: '/legal-prestamos',
            url: '/legal-prestamos',
            title: 'INSURANCE DMG',
            private: false,
            mandatoryPermissions: [],
            permissions: [CAN_READ_LEGAL_LOANS],
          },
        ],
      },
      {
        icon: 'sli-menu',
        title: 'Panel financiero',
        private: false,
        items: [
          {
            pathname: '/movimientos',
            url: '/movimientos',
            title: 'Movimientos',
            private: false,
            mandatoryPermissions: [],
            permissions: [CAN_READ_MOVEMENTS],
          },
          {
            pathname: '/resumen-movimientos',
            url: '/resumen-movimientos',
            title: 'Resumen general',
            private: false,
            mandatoryPermissions: [],
            permissions: [CAN_READ_MOVEMENTS_SUMMARY],
          },
          {
            pathname: '/cuentas-bancarias',
            url: '/cuentas-bancarias',
            title: 'Cuentas bancarias',
            private: false,
            mandatoryPermissions: [CAN_READ_BANK_ACCOUNTS],
            permissions: [],
          },
        ],
      },
      {
        icon: 'sli-menu',
        title: 'Admin',
        private: false,
        items: [
          {
            pathname: '/crear-solicitud',
            url: '/crear-solicitud',
            title: 'Crear solicitud',
            private: false,
            mandatoryPermissions: [],
            permissions: [CAN_CREATE_LOAN_APPLICATION_FROM_CRM],
          },
          {
            pathname: '/permisos',
            url: '/permisos',
            title: 'Permisos',
            private: false,
            mandatoryPermissions: [],
            permissions: [CAN_CREATE_PERMISSIONS, CAN_READ_PERMISSIONS],
          },

          {
            pathname: '/usuarios',
            url: '/usuarios',
            title: 'Usuarios',
            private: false,
            mandatoryPermissions: [],
            permissions: [CAN_READ_PROFILES],
          },

          {
            pathname: '/corredores',
            url: '/corredores',
            title: 'Agentes',
            private: false,
            mandatoryPermissions: [CAN_READ_BROKERS],
            permissions: [],
          },
          {
            pathname: '/grupos',
            url: '/grupos',
            title: 'Grupos',
            private: false,
            mandatoryPermissions: [CAN_READ_GROUPS],
            permissions: [],
          },
          {
            pathname: '/departamentos',
            url: '/departamentos',
            title: 'Departamentos',
            private: false,
            mandatoryPermissions: [CAN_READ_DEPARTMENTS],
            permissions: [],
          },
          {
            pathname: '/posiciones',
            url: '/posiciones',
            title: 'Posiciones',
            private: false,
            mandatoryPermissions: [CAN_READ_POSITIONS],
            permissions: [],
          },
        ],
      },
      {
        icon: 'sli-menu',
        title: 'Investment Panel',
        private: false,
        items: [
          {
            pathname: '/products',
            url: '/products',
            title: 'Products',
            private: false,
            mandatoryPermissions: [CAN_READ_PRODUCTS.value],
            permissions: [],
          },
          {
            pathname: '/users',
            url: '/users',
            title: 'Users',
            private: false,
            mandatoryPermissions: [CAN_READ_WALLET_USERS.value],
            permissions: [],
          },
        ],
      },
      {
        pathname: '/terms',
        url: '/terms',
        icon: '',
        title: 'Terms & Conditions',
        private: false,
        mandatoryPermissions: [],
        permissions: [CAN_EDIT_TERMS_AND_CONDITIONS_OF_USE.value],
        items: [],
      },
    ],
  },
];
// eslint-disable-next-line import/prefer-default-export
export function navigation(state = Array.from(urls), action) {
  switch (action.type) {
    case 'SET_NAVIGATION':
      return Object.assign({}, state, {
        ...action.navigation,
      });
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/navigation.js